module.exports = new __parcel__URL__("nldas-cover.cbabde54.png").toString();